import "./AddDashboardWidgetDialog.scss";
import template from "./AddDashboardWidgetDialog.html";
import {IComponentOptions, IOnDestroy} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {widgetImplemented, WidgetType, widgetTypeName} from "../../../models/WidgetType";
import {ascendingUsing} from "../../../../../js/util/UtilFunctions";
import {DashboardViewStore} from "../../../store/DashboardViewStore";
import {Observable, ReplaySubject} from "rxjs";

export const AddDashboardWidgetDialog = "tfAddDashboardWidgetDialog";

export function addDashboardWidgetDialog(): IComponentOptions {
    return {
        template,
        bindings: {
            modalInstance: "<"
        },
        controllerAs: "ctrl",
        controller: AddDashboardWidgetDialogComponent
    };
}

export class AddDashboardWidgetDialogComponent implements IOnDestroy {
    public readonly modalInstance: IModalInstanceService;
    public readonly availableWidgetTypes$: Observable<ReadonlyArray<WidgetType>>;
    private readonly destroy$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(dashboardViewStore: DashboardViewStore) {
        this.availableWidgetTypes$ = dashboardViewStore.availableWidgetTypes
                                                       .map((widgets) => this.filterAndSort(widgets))
                                                       .takeUntil(this.destroy$);
    }

    private filterAndSort(widgets: ReadonlyArray<WidgetType>): ReadonlyArray<WidgetType> {
        return widgets.filter((w) => widgetImplemented(w))
                      .sort(ascendingUsing(widgetTypeName));
    }

    public $onDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
